export default "__VITE_ASSET__be54815d__"